export default __webpack_public_path__ + "static/media/chicken.2d84c623.png";